import React from 'react';
import PropTypes from 'prop-types';

const ContentWrapper = ({ children, header, headerDesc = null, description, className = '' }) => (
  <div className={`col-12 col-lg-8 px-4 ${className}`}>
    <div className='mb-4'>
      {headerDesc}
      {header && <h2 className='py-4'>{header}</h2>}
      {description && <div>{description}</div>}
    </div>
    <div className='col-12 pb-2 px-0'>
      {children}
    </div>
  </div>
);

ContentWrapper.propTypes = {
  header: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
    PropTypes.string,
  ]),
  className: PropTypes.string,
  headerDesc: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
    PropTypes.string,
  ]),
  description: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
    PropTypes.string,
  ]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.bool,
    ])),
    PropTypes.element,
  ]),
};

export default ContentWrapper;
